import ease from '@/constants/ease';
import { AnimatePresence, motion } from 'framer-motion';
import { Feature } from './TabbedAnimatedCarousel';

export type CarouselDesktopActiveFeatureProps = {
  activeFeature: Feature;
}
export const CarouselDesktopActiveFeature = ({ activeFeature }: CarouselDesktopActiveFeatureProps) =>
  <div className="hidden md:block w-full aspect-[1222/688] relative">
    <AnimatePresence mode="wait">
      {activeFeature && (
        <motion.div
          key={activeFeature.title}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 400 / 1000,
            ease: ease.appear,
          }}
        >
          <div className="grid grid-cols-12 gap-x-gutter-mobile md:gap-x-gutter-desktop gap-y-3">
            <div className="col-span-12 lg:col-span-10 lg:col-start-2">
              <div className="rounded-10 overflow-hidden">{activeFeature.image}</div>
            </div>
            <div className="col-span-10 col-start-2 lg:col-span-6 lg:col-start-4">
              <p className="text-14/20 text-gray-700 text-center">{activeFeature.description}</p>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
